// The naming convention for uploaded images, in one place so the code that
// writes a name and the code that reads a time back out cannot drift.
//
//   content/<block>/<base36 millis>-<random>.<ext>
//
// Encoding the upload time in the name means the gallery can order by it
// without a second Firestore field on every image, and without a Storage
// listing on every page view. Deliberately no imports: this module is reached
// from the public bundle, which must stay free of the Storage SDK.

export function newImagePath(block, ext = 'webp') {
  const id = crypto.randomUUID().replaceAll('-', '').slice(0, 20);
  return `content/${block}/${Date.now().toString(36)}-${id}.${ext}`;
}

// Returns the upload time in millis, or 0 for anything not named by us (a
// hand-pasted URL, or a file from before this convention).
export function uploadedAt(url) {
  if (typeof url !== 'string' || !url) return 0;
  try {
    // Storage download URLs percent-encode the path, so the last separator may
    // be "/" or "%2F".
    const path = decodeURIComponent(url.split('?')[0]);
    const file = path.slice(path.lastIndexOf('/') + 1);
    const stamp = file.split('-')[0];
    if (!/^[0-9a-z]{6,10}$/.test(stamp)) return 0;
    const millis = parseInt(stamp, 36);
    // Sanity-check the range so a random filename cannot masquerade as a date.
    return millis > 1_500_000_000_000 && millis < 4_000_000_000_000 ? millis : 0;
  } catch {
    return 0;
  }
}
